(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wgac-cookie-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'wgac-cookie-banner-dismissed';

    function dismissBanner(banner) {
      if (!banner) return;
      banner.hidden = true;
      banner.style.display = 'none';

      try {
        window.localStorage.setItem(storageKey, 'true');
      } catch (error) {
        // Ignore storage failures in private browsing or restricted contexts.
      }
    }

    function initBanner(banner) {
      if (!banner || banner.dataset.wgacCookieReady === 'true') return;

      banner.dataset.wgacCookieReady = 'true';

      try {
        if (window.localStorage.getItem(storageKey) === 'true') {
          dismissBanner(banner);
          return;
        }
      } catch (error) {
        // Ignore storage failures and continue showing the banner.
      }

      banner.querySelectorAll('[data-wgac-cookie-dismiss]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          dismissBanner(banner);
        });
      });
    }

    function initAllBanners() {
      document.querySelectorAll('[data-wgac-cookie-banner]').forEach(initBanner);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllBanners, { once: true });
    } else {
      initAllBanners();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const banner = event.target && event.target.querySelector('[data-wgac-cookie-banner]');
      if (banner) initBanner(banner);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
